/**
 * VB New - Entradas
 * Agrega la variante de la entrada al carrito y redirige a /cart.
 */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.vbnReady) return;
    root.dataset.vbnReady = 'true';

    var addUrl = root.getAttribute('data-cart-add-url');
    var cartUrl = root.getAttribute('data-cart-url');
    var errorBox = root.querySelector('[data-vbn-tickets-error]');

    root.querySelectorAll('[data-vbn-ticket-add]').forEach(function (button) {
      button.addEventListener('click', function () {
        var variantId = button.getAttribute('data-variant-id');
        if (!variantId || button.disabled) return;

        button.disabled = true;
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        if (errorBox) errorBox.hidden = true;

        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('HTTP ' + response.status);
            return response.json();
          })
          .then(function () {
            console.log('[VBN Tickets] Variante agregada:', variantId);
            window.location.href = cartUrl;
          })
          .catch(function (error) {
            console.log('[VBN Tickets] Error al agregar al carrito:', error);
            button.disabled = false;
            button.classList.remove('is-loading');
            button.removeAttribute('aria-busy');
            if (errorBox) errorBox.hidden = false;
          });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-vbn-tickets]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector('[data-vbn-tickets]'));
  });
})();
